import { render } from "./Nav.vue?vue&type=template&id=7e0da84d&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=7e0da84d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0da84d"]])

export default __exports__